import React from "react";
import { useWebData } from "../../Context/webDataContext";
import defaultFrameImg from "../homeScreens/joinFrame.svg";

const defaultGooglePlayBadge =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png";
const defaultAppStoreBadge =
  "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";

function ServiceProviderJoin() {
  const { getServiceProviderJoinData } = useWebData();
  const joinData = getServiceProviderJoinData();

  const heading = joinData.heading || "Join Maideaze as a Service Provider";
  const paragraph1 =
    joinData.paragraph1 ||
    "At Maideaze, we empower service providers with opportunities to grow and succeed.";
  const paragraph2 =
    joinData.paragraph2 ||
    "Whether you're a cleaner, babysitter, cook, or caregiver, we offer a platform that values your skills and dedication.";
  const frameImage = joinData.frameImg || defaultFrameImg;
  const googlePlayBadge = joinData.googlePlayBadge || defaultGooglePlayBadge;
  const appStoreBadge = joinData.appStoreBadge || defaultAppStoreBadge;
  const playStoreLink = joinData.playStoreLink || "#";
  const appStoreLink = joinData.appStoreLink || "#";

  return (
    <section className="w-full bg-white md:py-20 py-4" id="service-providers">
      <div className="flex flex-col md:flex-row items-center md:justify-between md:gap-12 gap-5">
        {/* Left Column */}
        <div className="md:w-1/2 text-center md:text-left">
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#08875D] md:mb-6 mb-4 leading-tight">
            {heading}
          </h2>
          <p className="md:text-lg text-base text-gray-700 mb-4">{paragraph1}</p>
          <p className="md:text-lg text-base text-gray-700 mb-6">{paragraph2}</p>
          <div className="flex justify-center md:justify-start gap-4">
            <a
              href={playStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on Google Play"
              className="transition-transform duration-300 hover:scale-105"
            >
              <img
                src={googlePlayBadge}
                alt="Google Play Store"
                className="h-14 object-contain drop-shadow-lg"
              />
            </a>
            <a
              href={appStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
              className="transition-transform duration-300 hover:scale-105"
            >
              <img
                src={appStoreBadge}
                alt="Apple App Store"
                className="h-14 object-contain drop-shadow-lg"
              />
            </a>
          </div>
        </div>

        {/* Right Column */}
        <div className="md:w-1/2 flex justify-center items-center relative">
          <div className="relative max-w-sm w-full p-4 rounded-2xl bg-white/50 backdrop-blur-md">
            <img
              src={frameImage}
              alt="Maideaze Phone Mock"
              className="w-full rounded-xl transition-transform duration-300 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceProviderJoin;
